import { MfPath, mfPath2str } from "../MFormTypes";
import { MfNode } from "../node";
import { buildOwners } from "./buildOwners";

/* eslint no-restricted-syntax: "off" */
/* eslint no-await-in-loop: "off" */

export const activateByPath = async (
  root: MfNode,
  path: MfPath,
): Promise<void> => {
  const nodes = buildOwners(root, path);
  if (!nodes)
    throw Error(
      `Not found path [${mfPath2str(path)}] in [${mfPath2str(root.dataPath)}]`,
    );
  let curPath = path;
  for (const curNode of nodes) {
    if (curNode.dataKey && curNode.dataKey === curPath[0]) {
      curPath = curPath.slice(1);
    }
    if (curNode.activate) {
      await curNode.activate(curPath[0], curPath);
    }
  }
};
